import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  Flex,
  FormControl,
  FormErrorMessage,
  Icon,
  SimpleGrid,
  Text,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
import { MdInfoOutline } from 'react-icons/md';
import DrawerCloseButton from 'components/drawer/DrawerCloseButton';
import { renderInputElement } from 'helpers/formHelper';
import PropTypes from 'prop-types';
import { Fragment, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';



const EditCustomerSettings = ({ fields, data, onSave }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (isOpen && data) {
      reset(data);
    }
  }, [isOpen, data, reset]);

  const onSubmit = (_data) => {
    onSave(_data);
    onClose();
  };

  return (
    <>
      <Button variant={'brand'} onClick={onOpen}>
        Edit Settings
      </Button>
      <Drawer blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl>
            <DrawerContent maxW={{ base: 'calc(100vw - 32px)', md: '427px' }}>
              <DrawerCloseButton onClose={onClose} />
              <DrawerBody>
                <SimpleGrid
                  gridTemplateColumns={'min-content min-content'}
                  whiteSpace={'nowrap'}
                  justifyContent={'space-between'}
                  spacingY={4}
                  alignItems={'center'}
                  fontSize={'sm'}
                >
                  <Text fontSize={'16px'} fontWeight={800}>
                    Edit Settings
                  </Text>
                  <Box></Box>
                  {fields.map((item, index) => (
                    <Fragment key={index}>
                      <Flex alignItems={'center'} gap={1}>
                        <Text>{item.label}</Text>
                        {item.tooltip && (
                          <Tooltip label={item.tooltip} placement={'top'}>
                            <span>
                              <Icon as={MdInfoOutline} color={'secondaryGray.600'} />
                            </span>
                          </Tooltip>
                        )}
                      </Flex>
                      <Flex
                        gap={'5px'}
                        alignItems={'center'}
                        justifyContent={'flex-end'}
                      >
                        <Box w={200}>
                          <FormControl isInvalid={Boolean(errors[item.name])}>
                            <Controller
                              control={control}
                              name={item.name}
                              rules={{
                                ...(item.rules || {}),
                                ...(item.validate ? { validate: item.validate } : {}),
                              }}
                              render={(controllerField) =>
                                renderInputElement({
                                  item: {
                                    ...item,
                                    props: {
                                      ...(item.props || {}),
                                      ...(item.getExtraProps
                                        ? item.getExtraProps(watch())
                                        : {}),
                                    },
                                  },
                                  styleProps: { fontWeight: 800, w: 200 },
                                  showPrefix: true,
                                })(controllerField)
                              }
                            />
                            <FormErrorMessage>
                              {errors[item.name]?.message}
                            </FormErrorMessage>
                          </FormControl>
                        </Box>
                      </Flex>
                    </Fragment>
                  ))}
                </SimpleGrid>
              </DrawerBody>
              <DrawerFooter>
                <Flex justify={'end'}>
                  <Button type={'submit'} variant={'brand'} w={200}>
                    Save
                  </Button>
                </Flex>
              </DrawerFooter>
            </DrawerContent>
          </FormControl>
        </form>
      </Drawer>
    </>
  );
};

EditCustomerSettings.propTypes = {
  fields: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditCustomerSettings;
